import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import FormsList from './FormsList'
import Header from './Header'
import Footer from './Footer'
import { storeToken } from '../actions'
const DEBUG=window.configuration.debug;
import jwtDecode from 'jwt-decode';
import queryString from 'query-string';
import fetch from 'isomorphic-fetch';
import { ToastContainer} from 'react-toastify';

class SurveyList extends Component {
    static childContextTypes= {
        location: React.PropTypes.object
    }
    static contextTypes = {
        router: React.PropTypes.object
    }

  constructor(props) {
    super(props);
    //console.log(props);
  }

  componentDidMount() {
      const { hash } = this.props.location;
      var parsed = queryString.parse(this.props.location.search);
      const MAINTENANCEWINDOW = window.configuration.maintenancewindow;
      const MAINTENANCEWINDOWTITLE = window.configuration.maintenancewindowtitle;
      const MAINTENANCEWINDOWTEXT = window.configuration.maintenancewindowtext;

      const SP_URL = window.configuration.spUrl;
      const SP_RESPONSE_TYPE = window.configuration.sp_response_type;
      const SP_REDIRECT_URI = window.configuration.sp_redirectUri;
      const SP_SCOPE= window.configuration.sp_scope;
      const SP_STATE= window.configuration.sp_state;
      const SP_CLIENT_ID= window.configuration.sp_clientId;
      const SP_IDENTITY_CUSTOMER= window.configuration.sp_identity_provider_customer;
      const SP_IDENTITY_INTERNAL= window.configuration.sp_identity_provider_internal;
      const REFRESH_URL= window.configuration.refreshUrl;

      const {user} = this.props;

      if(parsed.code) {
        //remove token if it exists and it is expired
        if (sessionStorage.getItem('spasts_token') !== null) {
          const decoded = jwtDecode(sessionStorage.getItem('spasts_token'));
          if (decoded.exp < Math.floor(Date.now() / 1000)) {
              sessionStorage.removeItem('spasts_token')
          }
        }
        let body = `grant_type=authorization_code&client_id=${SP_CLIENT_ID}&code=${parsed.code}&redirect_uri=${SP_REDIRECT_URI}`;

        fetch(`${REFRESH_URL}`, {
          headers: new Headers({
              'Content-Type': 'application/x-www-form-urlencoded'
          }),
          method: 'post',
          body,
        }).then(response => {
          if (response.status === 401) {
              return {'error': "not authorized"}
          }   
          return response.json()
        }).then(keys => {
            this.props.dispatch(storeToken(keys.id_token, keys.refresh_token));
            this.context.router.push('/');
      });
      }
  }
  renderMaintenanceMessage() {
      const MAINTENANCEWINDOWTITLE = window.configuration.maintenancewindowtitle;
      const MAINTENANCEWINDOWTEXT = window.configuration.maintenancewindowtext;
      return (
          <div className="row col-xs-12">
              <div className="alert alert-success" role="alert">
                  <h3>{MAINTENANCEWINDOWTITLE}</h3>
                  <p>{MAINTENANCEWINDOWTEXT}</p>

              </div>

          </div>
      );
  }
  render() {
    const { user } = this.props;
    const MAINTENANCEWINDOW = window.configuration.maintenancewindow;
    const MAINTENANCEWINDOWTITLE = window.configuration.maintenancewindowtitle;
    const MAINTENANCEWINDOWTEXT = window.configuration.maintenancewindowtext;
    return (
      <div className="main-container">
        <div id="wrap">
          <Header fetching={this.props.forms.isFetching} activepage="surveylist" />
          <div className="container center-container">
            <div className="center-row">
              <div className="col-xs-12">
                <h2>{!MAINTENANCEWINDOW && user != undefined && user.survey_role === 'EXTERNAL' ? 'My surveys' : 'All surveys'}</h2>
                  <div className="col-xs-12">
                  {MAINTENANCEWINDOW ? this.renderMaintenanceMessage() : ''}
                  </div>
                  <div className="col-xs-12">
                    {user === undefined ? <p>You need to login first</p> : '' }
                    {!MAINTENANCEWINDOW && user !== undefined && user.survey_role === 'EXTERNAL' ?  <FormsList /> : '' }
                    {user !== undefined && user.survey_role === 'INTERNAL' ? <FormsList /> : '' }
                    <ToastContainer />
                  </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )
  }
}

SurveyList.propTypes = {}

function mapStateToProps(state) {
    const { user, forms } = state;
    const isFetching = forms.isFetching
    
    return {
        user: user.user,
        forms,
        isFetching,
    }
}

export default connect(mapStateToProps)(SurveyList)


// WEBPACK FOOTER //
// ./src/containers/SurveyList.js